// extracted by css-extract-rspack-plugin
export default {"small_button_override":"PECVP","smallButtonOverride":"PECVP","#":"wcTXv"};